import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { getPositionedFields, getSampleValues } from '@/services/utils/pdf/pdfFieldPosition';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const robotoFonts = {
    Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
    }
};

const printFieldPositionSample = (fields, positions) => {
    const doc = {
        pageSize: 'A4',
        background: { stack: getPositionedFields(positions, getSampleValues(fields)) },
        content: [{ text: '' }],
        info: {
            title: 'Field Position Sample'
        }
    };

    pdfMake.createPdf(doc, null, robotoFonts).open();
}

export default printFieldPositionSample;
